import * as React from "react";
import { useParams } from "react-router-dom";
import { useGetSecretQuery } from "../../store/api/secretApi";
import { SecretDetailForm } from "./detailForm";
import { Loader } from "../../components/layout/loader";
import { IncorrectItem } from "../../components/generic/IncorrectItem/incorrectItem";
import { AccessRestrictedItem } from "../../components/generic/AccessRestrictedItem/accessRestrictedItem";

type RouteParams = "org" | "secret";
export const SecretDetailInitializer: React.FC = () => {
  const { org: orgName, secret: secretName } = useParams<RouteParams>();

  const selfLink = `/org/${orgName}/secret/${secretName}`;

  const { data: secret, isLoading, isFetching, isError, error, refetch } = useGetSecretQuery(selfLink, {
    skip: !selfLink,
    refetchOnMountOrArgChange: true,
  });

  if (!secret && isLoading) {
    return <Loader />;
  }

  const is403 = isError && (error as any)?.status === 403;
  if (is403) {
    return <AccessRestrictedItem kind="secret" />;
  }

  const is404 = isError && (error as any)?.status === 404;
  if (is404 || !secret) {
    return <IncorrectItem kind="secret" canCreate={true} />;
  }

  return <SecretDetailForm secret={secret} />;
};
